<template>
    <div id="planning_urusan" >

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">IKU OPD</span> <br> <br>
                    </div>
                    <div class="col-md-6">
                        
                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>

            <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <select class="form-control"  v-model="data.unit_kerja" @change="data.renstra_sasaran_id = '', cari_data()">
                                    <option v-for="data in list_OPD" :key="data.id" :value="data.id">{{data.unit_kerja}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="data.tahun" @change="cari_data()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Filter Sasaran</span>
                                <select class="form-control" v-model="data.renstra_sasaran_id" @change="cari_data()">
                                    <option value="" selected> -- Filter Sasaran --</option> 
                                    <option v-for="data in list_sasaran" :key="data.renstra_sasaran_id" :value="data.renstra_sasaran_id">{{data.uraian}}</option>
                                </select>
                            </div>
                        </div>
                        <br>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 25%">Uraian Indikator</th>
                            <th style="width: 5%" class="text-center">Satuan</th>
                            <th class="text-center" style="width: 8%">Target Renstra</th>
                            <th class="text-center" style="width: 8%">Target Thn ini</th>
                            <th class="text-center" style="width: 8%">Realisasi</th>
                            <th style="width: 15%">Rumus</th>
                            <th style="width: 21%">Keterangan</th>
                            <th style="width: 5%"></th>
                        </tr>
                        </thead>
                        <tbody>
                          <!-- track-by="data.createdtime" -->
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.urusan_pemerintahan_id">
                              <td class="text-center">{{index+1}}</td>
                              <td >{{data.uraian}}</td>
                              <td class="text-center">{{data.satuan}}</td>
                              <td class="text-center">{{getDataTahunSekarang(data)}}</td>
                               <td class="text-center">{{data.target_thn_ini}}</td>
                              <td class="text-center">{{data.capaian_thn_ini}}</td>
                              <td >{{data.rumus_satuan}}</td>
                               <td >{{data.keterangan}}</td>
                              <td class="text-center" >

                                <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                    <i class="material-icons" >create</i>
                                </button>
                              </td>
                          </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-md" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-12">
                                        <span>{{data.uraian}}</span> <br>
                                    </div>
                                </div>
                                <hr>


                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Target Thn ini</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.target_thn_ini" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Realisasi Thn ini</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.capaian_thn_ini" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                 

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/sakip_realisasi_iku_OPD/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const ADD_URL_SASARAN = URL_APP+'api/v1/planning_renstra_sasaran/';

    export default {
        name: "planning_urusan",
        data() {
            return {
                data:{
                    uraian : '',
                    renstra_sasaran_id : "",
                    renstra_indikator_sasaran_capaian_id: "",
                    renstra_indikator_sasaran_id: "",
                    target_thn_ini:0,
                    capaian_thn_ini: 0,
                    tahun : '2019',
                    unit_kerja : '',
                },
                kode_urusan: '',
                nama_urusan: '',
                urusan_pemerintahan_id: '',
                list_data: [],
                list_tahun : [],
                list_OPD : [],
                list_sasaran : [],
                page_first : 1,
                page_last : 0,
                cari_value : ''
            };
        },

        mounted() {


            var get_profile = JSON.parse(localStorage.profile);
            this.data.unit_kerja = get_profile.profile.unit_kerja;
            console.log(this.data.unit_kerja)


            this.getDataTahun();
            this.getOPD();
            

            // localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify(this.data)
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data)
                  this.list_data = res_data
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },

            selectData : function(data){
                    var renstra_indikator_sasaran_capaian_id = data.renstra_indikator_sasaran_capaian_id;

                    if (renstra_indikator_sasaran_capaian_id == null || renstra_indikator_sasaran_capaian_id== undefined || renstra_indikator_sasaran_capaian_id == '') {
                        this.data.renstra_indikator_sasaran_capaian_id = '';
                    } else {
                        this.data.renstra_indikator_sasaran_capaian_id = renstra_indikator_sasaran_capaian_id;
                    }

                    this.data.renstra_indikator_sasaran_id =  data.renstra_indikator_sasaran_id;
                    this.data.target_thn_ini = data.target_thn_ini;
                    this.data.capaian_thn_ini =  data.capaian_thn_ini;
                    this.data.unit_kerja  =  data.unit_kerja;
                    this.data.uraian = data.uraian;


                    console.log(this.data)
            
            },

            emptyData : function(){
                this.data = {
                    id: '',
                    kode_urusan: '',
                    nama_urusan: '',
                    user: '',
                    createdtime: ''
                };
                this.kode_urusan= '';
                this.nama_urusan= '';
                this.urusan_pemerintahan_id= '';
            },

            //PAGINASI
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_tahun = res_data;
                    this.data.tahun = this.getTgl().tahun;
                    // this.getDataTahunSekarang();
                    // console.log('Bangsat')
                    // this.getSetupRenstra();
                })
            },
            getOPD: function(){
                fetch(ADD_URL_UNIT_KERJA + 'getSelectUnitKerja', {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_OPD = res_data;
                   
                    this.getSasaran();
                    this.getData();
                })
            },
            getSasaran: function(){
                fetch(ADD_URL_SASARAN + 'selectSasaran', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data)
                    this.list_sasaran = res_data;
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear()-1,
                }
            },

            getDataTahunSekarang(data){
                var thn_awal = 2016;
                var thn_ahir = 2021
                var thn_length = (thn_ahir - thn_awal);
                var list_tahun = [thn_awal];
                var thn_saat_ini = this.data.tahun;

                for (let i = 0; i < thn_length; i++) {
                    thn_awal = thn_awal+1
                    list_tahun.push(thn_awal)
                }


                // return this.data.tahun;

                // console.log(list_tahun)

                    if (thn_saat_ini == list_tahun[0]) {
                        return data.thn_1;
                    } 
                    else if (thn_saat_ini == list_tahun[1]) {
                        return data.thn_2;
                    }
                    else if (thn_saat_ini == list_tahun[2]) {
                        return data.thn_3;
                    }
                    else if (thn_saat_ini == list_tahun[3]) {
                        return data.thn_4;
                    }
                    else if (thn_saat_ini == list_tahun[4]) {
                        return data.thn_5;
                    }
                    else if (thn_saat_ini == list_tahun[5]) {
                        return data.thn_6;
                    }

            },

            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
                // this.getDataTahun();
                this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
